import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";

//Images
import pic1 from "./../../../../images/comapny/1.png";
import pic2 from "./../../../../images/comapny/2.png";
import pic3 from "./../../../../images/comapny/3.png";
import pic4 from "./../../../../images/comapny/4.png";
import pic5 from "./../../../../images/comapny/5.png";
import pic6 from "./../../../../images/comapny/6.png";

const Companyblog = [
  { image: pic1, title: "Kleon Team" },
  { image: pic2, title: "Ziro Studios Inc." },
  { image: pic3, title: "Qerza" },
  { image: pic4, title: "Kripton Studios" },
  { image: pic5, title: "Omah Ku Inc." },
  { image: pic6, title: "Ventic" },
  { image: pic4, title: "Sakola" },
  { image: pic2, title: "Uena Foods" },
  { image: pic6, title: "Ventic" },
  { image: pic4, title: "Sakola" },
];

const FeaturedCompanies = (props) => {
  const [companies, setCompanies] = useState([]);
  const [data, setData] = useState(Companyblog);

  useEffect(() => {
    // console.log("Props companies:", props?.companies);
    setCompanies(props?.companies || []);
  }, [props.companies]);

  // useEffect(() => {
  //   console.log(companies);
  // }, [companies]);

  return (
    <>
      <div className="card">
        <div className="card-header border-0 pb-0">
          <h4 className="fs-20 mb-1" style={{ height: "60px" }}>
            Top 10 Companies
          </h4>
        </div>
        <div className="card-body pt-3 loadmore-content">
          <div className="row" id="FeaturedCompaniesContent">
            {companies?.max_hired_by_company &&
            companies?.max_hired_by_company.length > 0 ? (
              companies.max_hired_by_company?.map((item, index) => (
                <div
                  className={`col-xl-6 col-sm-6 ${
                    index == 0 || index == 1 ? "" : "mt-4"
                  }`}
                  key={index}
                >
                  <div className="d-flex" style={{ alignItems: "center" }}>
                    {data[index] && (
                      <img src={data[index].image} alt={item.company_name} />
                    )}
                    <div className="ms-3 featured">
                      <h4 className="fs-18 mb-1">{item.company_name}</h4>
                      <span>Total Offers : {item.student_count}</span>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p>No Companies Found</p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default FeaturedCompanies;
